type ErrorRecord = Record<string, unknown>;

export interface ChatFailureDiagnostic {
  code?: string;
  status?: number;
}

const asRecord = (value: unknown): ErrorRecord | undefined =>
  value !== null && typeof value === 'object'
    ? (value as ErrorRecord)
    : undefined;

const safeCode = (value: unknown): string | undefined =>
  typeof value === 'string' && /^[a-z0-9_.-]{1,64}$/i.test(value)
    ? value
    : undefined;

const safeStatus = (value: unknown): number | undefined =>
  typeof value === 'number' && Number.isInteger(value) && value >= 100 && value <= 599
    ? value
    : undefined;

export const getChatFailureDiagnostic = (
  error: unknown
): ChatFailureDiagnostic => {
  const root = asRecord(error);
  const response = asRecord(root?.response);

  return {
    ...(safeCode(root?.code) ? { code: safeCode(root?.code) } : {}),
    ...(safeStatus(response?.status ?? root?.status)
      ? { status: safeStatus(response?.status ?? root?.status) }
      : {}),
  };
};

export const logChatFailure = (operation: string, error?: unknown): void => {
  console.warn(`[AI chat] ${operation} failed.`, getChatFailureDiagnostic(error));
};
